import { render, staticRenderFns } from "./AdminForm.vue?vue&type=template&id=1c7481a6&scoped=true&"
import script from "./AdminForm.vue?vue&type=script&lang=js&"
export * from "./AdminForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminForm.vue?vue&type=style&index=0&id=1c7481a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7481a6",
  null
  
)

export default component.exports